/**
 * Webroot URL for folder ./web/
 * including trailing slash
 */
export const BASEURL: string = (window as any).BASEURL;
/**
 * Website home of current language
 * including trailing slash
 */
export const SITEURL: string = (window as any).SITEURL;

export const ISLOGGEDIN: boolean = (window as any).ISLOGGEDIN;

export const CRAFT_TRANSLATIONS: Record<string, string> = (window as any)
    .CRAFT_TRANSLATIONS;

export const LANG: "de" | "en" | "fr" = (window as any).LANG;

export const OCISID: string = (window as any).OCISID;

export const CB_BRANDS: string = (window as any).CB_BRANDS;

export const USEREMAIL: string = (window as any).USEREMAIL;
